import clone from 'lodash.clonedeep';

const options = {
    showMaskOnFocus: true,
    showMaskOnHover: false,
};

const InputmaskConstructor = {
    constructor: null,
};

export default {
    async bind(el, bind, vNode) {
        const placeholder = vNode?.context?.maskPlaceholder.length ? vNode?.context?.maskPlaceholder : '_';
        const opt = {
            ...clone(options),
            placeholder,
        };

        if (typeof bind.value !== 'object') {
            console.warn(`Mask directive must take an object as its value. Wrong type for element with id="${el.id}"`);
        }

        if (bind.value.mask && bind.value.mask.length) {
            await _setInputmask({el, bind, vNode, opt});
        }
    },
    inserted(el) {
        if (el.value) {
            el.dispatchEvent(new Event('input'));
        }
    },
    async componentUpdated(el, bind, vNode) {
        const placeholder = vNode?.context?.maskPlaceholder.length && !vNode.context.value
            ? vNode?.context?.maskPlaceholder
            : '_';
        const opt = {
            ...clone(options),
            placeholder,
        };

        if (bind.value.mask !== bind.oldValue.mask) {
            await _setInputmask({el, bind, vNode, opt});
        }
    },
};

async function _setInputmask({el, bind, vNode, opt}) {
    await _importInputmask();

    const mask = !bind.arg ? {mask: bind.value.mask} : {regex: bind.value.mask};
    if (el.dataset.isMaskPlaceholderDisabled && el.dataset.isMaskPlaceholderDisabled === 'true') {
        opt.placeholder = '';
    }
    InputmaskConstructor.constructor({...mask, ...opt}).mask(el);

    if (el.value && bind.value.revalidate) {
        setTimeout(() => {
            const formattedValue = InputmaskConstructor.constructor.format(el.value, mask);
            formattedValue && vNode.context.$emit('input', formattedValue);
        }, 0);
    }
}

async function _importInputmask() {
    if (!InputmaskConstructor.constructor) {
        const {default: Inputmask} = await import('@/core/lib/inputmask');

        InputmaskConstructor.constructor = Inputmask;
    }
};
